/**
 * @file Общее оформление обычного и одноразового входа.
 *
 * Компонент отвечает за карточку, язык и заголовок вкладки. Содержимое формы
 * и выполнение входа передаются снаружи через props и children.
 */
import { useEffect, useId } from 'react'
import type { ReactNode } from 'react'

import { messages } from '../../i18n/messages'
import { useLocale } from '../../i18n/useLocale'
import './SignInPage.css'

export default function AuthCard({
    title,
    description,
    children,
}: {
    title: string
    description: string
    children: ReactNode
}) {
    const { locale, changeLocale } = useLocale()

    const id = useId()

    useEffect(() => {
        document.title = `${title} · Cloud-box`
    }, [title])

    return (
        <main className='sign-in-page'>
            <section className='sign-in-card' aria-labelledby={id}>
                {/* Одинаковая шапка и выбор языка у обычного входа и OTAT. */}
                <header className='sign-in-header'>
                    <p className='sign-in-brand'>Cloud-box</p>

                    <select
                        className='sign-in-language'
                        aria-label={messages[locale].language}
                        value={locale}
                        onChange={(event) =>
                            changeLocale(
                                event.target.value === 'ru' ? 'ru' : 'en',
                            )
                        }
                    >
                        <option value='ru' lang='ru'>
                            Русский
                        </option>
                        <option value='en' lang='en'>
                            English
                        </option>
                    </select>
                </header>

                <h1 id={id}>{title}</h1>

                <p className='sign-in-description'>{description}</p>

                {/* Конкретный экран подставляет сюда форму входа или состояние одноразовой ссылки. */}
                {children}
            </section>
        </main>
    )
}
